/**
 * Central test-id registry. Every interactive or critical UI element
 * should reference an id from here. Keep names kebab-case and semantic.
 */
export const TID = {
  // Layout
  navLogo: "nav-logo",
  navLink: (slug) => `nav-link-${slug}`,
  navNewsletterCta: "nav-newsletter-cta",
  navMobileToggle: "nav-mobile-toggle",
  navMobileMenu: "nav-mobile-menu",
  footerNewsletterEmail: "footer-newsletter-email",
  footerNewsletterSubmit: "footer-newsletter-submit",

  // Home
  heroSearchInput: "hero-search-input",
  heroSearchSubmit: "hero-search-submit",
  heroPrimaryCta: "hero-primary-cta",
  heroSecondaryCta: "hero-secondary-cta",
  categoryCard: (slug) => `category-card-${slug}`,
  featuredCalculatorCard: (slug) => `featured-calc-${slug}`,
  featuredArticleCard: (slug) => `featured-article-${slug}`,

  // Newsletter (shared)
  newsletterEmail: "newsletter-email",
  newsletterFirstName: "newsletter-first-name",
  newsletterConsent: "newsletter-consent",
  newsletterSubmit: "newsletter-submit",
  newsletterSuccess: "newsletter-success",
  newsletterError: "newsletter-error",

  // Calculators
  calcCard: (slug) => `calc-card-${slug}`,
  loanAmount: "loan-amount-input",
  loanRate: "loan-rate-input",
  loanTerm: "loan-term-input",
  loanCompute: "loan-compute-btn",
  loanReset: "loan-reset-btn",
  loanResultMonthly: "loan-result-monthly",
  loanResultTotalInterest: "loan-result-total-interest",
  loanResultTotalPaid: "loan-result-total-paid",
  loanToggleSchedule: "loan-toggle-schedule",
  loanSchedule: "loan-schedule",

  // Calculator template sections
  calcPlainEnglish: "calc-plain-english",
  calcAssumptions: "calc-assumptions",
  calcAskAi: "calc-ask-ai",
  calcAskAiPromptInput: "calc-ask-ai-prompt-input",
  calcAskAiSubmit: "calc-ask-ai-submit",
  calcNextSteps: "calc-next-steps",
  calcRelatedCalcs: "calc-related-calcs",
  calcRelatedArticles: "calc-related-articles",
  calcRelatedCalcCard: (slug) => `calc-related-calc-${slug}`,
  calcRelatedArticleCard: (slug) => `calc-related-article-${slug}`,

  // Framework v2 sections
  calcTrustBadges: "calc-trust-badges",
  calcInputsSection: "calc-inputs-section",
  calcResultsSection: "calc-results-section",
  calcButton: "calc-calculate-btn",
  calcResetButton: "calc-reset-btn",
  calcAdvancedToggle: "calc-advanced-toggle",
  calcSlider: (name) => `calc-slider-${name}`,
  calcSaveScenario: "calc-save-scenario",
  calcAddScenario: "calc-add-scenario",
  calcScenariosTable: "calc-scenarios-table",
  calcScenarioRow: (id) => `calc-scenario-row-${id}`,
  calcDeleteScenario: (id) => `calc-scenario-delete-${id}`,
  calcSetActiveScenario: (id) => `calc-scenario-activate-${id}`,
  calcWhatDoesThisMean: "calc-what-does-this-mean",
  calcWhatDoesThisMeanBtn: "calc-what-does-this-mean-btn",
  calcQuickAction: (id) => `calc-quick-action-${id}`,
  calcChartArea: "calc-chart-payment-over-time",
  calcChartDonut: "calc-chart-payment-breakdown",
  calcDownloadOption: (id) => `calc-download-${id}`,
  calcDownloadSection: "calc-download-section",
  calcAboutSection: "calc-about-section",

  // MyMoney AI
  aiResponseModal: "ai-response-modal",
  aiResponseModalBody: "ai-response-modal-body",
  aiResponseModalClose: "ai-response-modal-close",
  aiResponseModalRetry: "ai-response-modal-retry",
  aiResponseModalRemaining: "ai-response-modal-remaining",
  aiAskInput: "ai-ask-input",
  aiAskSubmit: "ai-ask-submit",
  aiFeatureCard: (id) => `ai-feature-${id}`,
  aiFollowUpInput: "ai-followup-input",
  aiFollowUpSubmit: "ai-followup-submit",
  aiChatUserMsg: "ai-chat-user-msg",
  aiChatAssistantMsg: "ai-chat-assistant-msg",
  aiLoginPrompt: "ai-login-prompt",
  aiLoginPromptBtn: "ai-login-prompt-btn",
  aiQuotaExhausted: "ai-quota-exhausted",
  aiQuotaUpgradeBtn: "ai-quota-upgrade-btn",

  // Auth / Account
  authLoginBtn: "auth-login-btn",
  authNavAvatar: "auth-nav-avatar",
  accountPage: "account-page",
  accountPlanPanel: "account-plan-panel",
  accountPlanName: "account-plan-name",
  accountPlanStatus: "account-plan-status",
  accountRemaining: "account-remaining",
  accountProfilePanel: "account-profile-panel",
  accountLogoutBtn: "account-logout-btn",
  accountCancelBtn: "account-cancel-btn",
  accountResumeBtn: "account-resume-btn",
  planCard: (id) => `plan-card-${id}`,
  planBuyBtn: (id) => `plan-buy-${id}`,
  boostCard: (id) => `boost-card-${id}`,
  boostBuyBtn: (id) => `boost-buy-${id}`,

  // Billing pages
  billingSuccessPanel: "billing-success-panel",
  billingSuccessTitle: "billing-success-title",
  billingSuccessBackToAccount: "billing-success-back",
  billingCancelPanel: "billing-cancel-panel",

  // Articles
  articleCard: (slug) => `article-card-${slug}`,
  articleBody: "article-body",

  // Pricing
  pricingPlan: (tier) => `pricing-plan-${tier}`,
  pricingCta: (tier) => `pricing-cta-${tier}`,
  pricingBoost: (size) => `pricing-boost-${size}`,
  pricingBoostCta: (size) => `pricing-boost-cta-${size}`,
  pricingWaitlistSection: "pricing-waitlist-section",
  pricingSelectedPlan: "pricing-selected-plan",

  // Contact
  contactName: "contact-name",
  contactEmail: "contact-email",
  contactSubject: "contact-subject",
  contactMessage: "contact-message",
  contactSubmit: "contact-submit",
  contactSuccess: "contact-success",
  contactError: "contact-error",
};
